import { render, staticRenderFns } from "./PaymentTotalDepositedRule.vue?vue&type=template&id=08faf584&"
import script from "./PaymentTotalDepositedRule.vue?vue&type=script&lang=js&"
export * from "./PaymentTotalDepositedRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports